module.exports = __webpack_public_path__ + "img/success_tick_icon.e79dcb8e.svg";